import type { DeviceSecurity } from '../pathLookup/Security';

// Request query schemas live with their endpoints (zod):
//   on-prem device tree  → controllers/security/get-security.ts
//   cloud NIC/subnet tree → controllers/security/get-cloud-security.ts
// Only the shared response shape (used by the frontend security tree) lives here.
export type DeviceSecurityResponse = {
  hostname: string;
  security: DeviceSecurity | null; // null in case there is no security defined for given box
};
